// extracted by mini-css-extract-plugin
export default {"list":"HomeBesookt_list__xwhOe"};